import React, {useRef} from 'react';
import {useField} from '@unform/core';
import PropTypes from 'prop-types';
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@material-ui/core";
import {withStyles} from "@material-ui/styles";

const CustomSelect = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                padding: '14px 14px',
                minHeight: '56px',
            },
        },
    },
})(FormControl);

function InputSelect({ name, label, placeholder="Selecione uma opção", ...props }) {
    const selectRef = React.useRef(null);
    const materialInputRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);
    
    // Garantir que options seja sempre um array válido
    const options = Array.isArray(props.options) ? props.options : [];

    React.useEffect(() => {
        registerField({
            name: fieldName,
            ref: selectRef.current,
            path: 'value',
            setValue(ref, value) {
                ref.value = value;

                materialInputRef.current
                    .querySelector("label")
                    .classList.add("MuiFormLabel-filled", "MuiInputLabel-shrink")
                ;
            },
            getValue: (ref) => {
                return selectRef.current.value;
            },
        });
    }, [fieldName, registerField]);

    return (
        <CustomSelect sx={{ width: '100%' }} error={!!error}>
            <InputLabel>{label}</InputLabel>
            <Select
                name={fieldName}
                ref={materialInputRef}
                inputRef={selectRef}
                defaultValue={defaultValue}
                label={label}
                fullWidth
                {...props}
            >
                <MenuItem value="">
                    {placeholder}
                </MenuItem>
                {options.length > 0 && options.map((option, index) => (
                    option && option.key !== undefined && option.value !== undefined ? (
                        <MenuItem key={option.key} value={option.key}>{option.value}</MenuItem>
                    ) : null
                ))}
            </Select>
            <FormHelperText error={!!error}>{error}</FormHelperText>
        </CustomSelect>
    );
}

export default InputSelect;

InputSelect.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};
